import { hbs } from 'ember-cli-htmlbars';
export default hbs("<div class=\'percentage-bar\' style={{percentage-bar-style @percentage @color}}>\n</div>")